import endpoint from '../services/endpoint'
import IcoPerfil from '../assets/img/iconMenu/icon-perfil.svg';

export const getUrl = (path) => {
    if (path != null) return path.includes('http') ? path : endpoint + path;
    else return IcoPerfil;
}
